import { encryptPDF } from '@pdfsmaller/pdf-encrypt';

/**
 * Applies standard AES-256 PDF encryption so viewers require the password to open the file.
 */
export async function applyPdfPassword(bytes: Uint8Array, password: string | null): Promise<Uint8Array> {
  const p = password?.trim();
  if (!p) return bytes;
  return encryptPDF(bytes, p, {
    algorithm: 'AES-256',
    allowPrinting: true,
    allowCopying: true,
    allowModifying: false,
    allowAnnotating: false,
    allowFillingForms: false,
    allowExtraction: false,
    allowAssembly: false,
    allowHighQualityPrint: true,
  });
}
